import styled from 'styled-components';

export const Wrapper = styled.div`
.css-p27qcy[aria-checked=true], .css-p27qcy[data-checked] {
    --switch-bg: #F8BC4E;
}
a,h1,h2,h3,h4,h5,h6,p,strong,span{
  font-family: 'Poppins', sans-serif;
}
p{
  margin: 0;
}
  /* Header Area */
  .menu-area {
    .nav-item {
      a {
        font-family: 'Poppins', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 36px;
        position: relative;
        transition: 0.3s;
      }
    }
    a:after {
      content: '';
      position: absolute;
      bottom: -20px;
      width: 0;
      height: 8px;
      background: linear-gradient(
        261.84deg,
        #f8bc4e 30.58%,
        #f14990 81.26%,
        rgba(72, 20, 44, 0.81) 136.94%
      );
      border-radius: 6px 6px 0px 0px;
      left: 0;
      transition: 0.3s;
      width: 0;
    }
    a:hover::after {
      width: 100%;
    }
    .active {
      position: relative;
      color: red;
      background: linear-gradient(
        264.95deg,
        #f8bc4e 16.87%,
        #f14990 76.77%,
        rgba(72, 20, 44, 0.81) 151.65%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
    .active::after {
      width: 100% !important;
    }
  }
  .header-btn {
    button {
      width: 202px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(
        261.84deg,
        #f8bc4e 30.58%,
        #f14990 81.26%,
        rgba(72, 20, 44, 0.81) 136.94%
      ) !important;
      box-shadow: -2px -6px 3px rgba(0, 0, 0, 0.25);
      border-radius: 40px;
      font-weight: 500;
      font-size: 24px;
      line-height: 132.5%;
      letter-spacing: -1.13533px;
      color: #f5f3ee;
      font-family: 'Poppins', sans-serif;
    }
  }

  .register {
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    color: rgba(248, 188, 78, 1);
  }

  /* Product */
  .Title_product{
    &::before{
      content:"";
    }
  }
.g-text{
    background: linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  }

  .gb-button{
    background: linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%);
    border-radius: 5px;
    color: #FFFFFF;
    height: auto;
    width:auto;
    &:hover{
      background: linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%);
    }
  }
.dashboard_menu{
  ul{
    li{
      position: relative;
      a{
        font-weight: 400;
        font-size: 16px;
        line-height: 21px;
        color: #000000;
      }

      &::before{
        content: "";
        position: absolute;
        top:0;
        left: 0;
        right: 0;
        background: #000000;
        border-radius: 0px 0px 3px 3px;
        width: 0;
        height: 4px;
        margin:auto;
        transition: 0.3s;
      }
    }
    li:hover ::before{
        width: 44px !important;
      }
      .active ::before{
        width: 44px;
      }
  }
  li.nav-link.css-10iahqc:hover::before {
    width: 44px;
    }
}

  /* media screen size 1261px */

  @media only screen and (max-width: 1395px){
        .css-1v5z18m {
        width: 266px;
    }
    .css-gavtwx{
      width: 228px;
    }
  }

  @media only screen and (max-width: 1261px) {
    /* signup page */
    .css-e5zz49 {
      width: 100%;
    }
    .css-11w0c5a {
      width: 75%;
    }
    /* login page */
    .css-xud1me {
      width: 100%;
    }
  }

  @media only screen and (max-width: 1100px) {
    .Mobile-menu {
      display: block;
      width: 90%;
      .logo-area {
        img {
          height: 136px;
        }
      }
    }

    .css-2p27im {
      align-items: center;
    }
    .desktop-menu {
      display: none;
    }

    /* footer */

    .css-11ze7cv {
      width: 30%;
    }
    .css-u8x7c4 {
      width: 70%;
      p {
        font-size: 18px;
      }
    }
  }
  /* media screen size 897px */

  @media only screen and (max-width: 897px) {
    .css-e5zz49 {
      width: 100%;
    }
    .css-11w0c5a {
      width: 90%;
    }
.css-16u46vb{
  flex-direction: column;
  justify-content:center;
  align-items:center
}
.css-11ze7cv {
      width: 100%;
    }
    .css-u8x7c4  {
      width: 100%;
    }
    .css-u8x7c4 {
	width: 100%;
	flex-wrap: wrap;
}
  }
  /* media screen size 761 */

  @media only screen and (max-width: 761px) {
    .signup {
      form {
        label {
          font-size: 16px;
        }
        input {
          font-size: 16px;
        }
      }
    }
    .login {
      form {
        label {
          font-size: 16px;
        }
        input {
          font-size: 16px;
        }
      }
      .css-xlinz7 {
        font-size: 16px;
      }
      .css-1giygmv {
        font-size: 16px;
      }
      button p {
        font-size: 18px;
      }
    }
    .chakra-button.css-72y55t {
      font-size: 18px;
    }
    .css-10ghr3f {
      font-size: 16px;
    }
    .register {
      font-size: 16px;
    }
    .css-e5zz49 {
      width: 100%;
    }
    .css-11w0c5a {
      width: 90%;
    }
  }

  @media only screen and (max-width: 600px) {
    .css-e5zz49 {
      padding: 10px;
    }
    .header-btn button {
      width: 168px;
      height: 48px;
      font-size: 18px;
    }
  }
  @media only screen and (max-width: 410px) {
    .signup {
      form {
        label {
          font-size: 14px;
        }
        input {
          font-size: 14px;
        }
      }
    }
    .css-xud1me {
      padding: 20px;
    }
    .css-n21gh5 {
      button p {
        font-size: 16px;
      }
    }
  }
`;
